import React, { Component } from 'react'
import { withFirebase } from '../Fb'

import { Button as BootstrapButton, Row, Col } from 'reactstrap'
import FalconModal from '../Inputs/FalconModal'
import {
  getMaintenancePlanTaskSchema,
  getMaintenancePlanTaskUISchema,
  getMaintenancePlanTaskExecutionSchema,
  getMaintenancePlanTaskExecutionUISchema,
} from '../Inputs/dataschemas'
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid'
import { Dialog } from '@mui/material'
import CardGrid from './CardGrid'

const statusses = {
  overdue: {
    title: 'Myöhässä',
    icon: 'fa fa-exclamation-circle',
    color: 'red',
  },
  upcoming: { title: 'Tulossa', icon: 'fa fa-clock', color: 'orange' },
  done: { title: 'Aikataulussa', icon: 'fa fa-check-circle', color: 'green' },
}

const FREQS = {
  weekly: 'Viikoittain',
  biweekly: 'Kahden viikon välein',
  monthly: 'Kuukausittain',
  quarterly: 'Neljännesvuosittain',
  semiannually: 'Puolivuosittain',
  annually: 'Vuosittain',
  biennially: 'Kahden vuoden välein',
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer style={{ justifyContent: 'space-between' }}>
      {/* <div style={{ display: 'flex', flexDirection: 'row' }}> */}
      <div style={{ flex: 1 }}>
        <GridToolbarColumnsButton title={'Näytä/piilota sarakkeet'} />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: 'laskutettavaa',
            delimiter: ';',
            utf8WithBom: true,
          }}
        />
      </div>
    </GridToolbarContainer>
  )
}

const getNextDueDate = (lastCompletionDate, start, frequency) => {
  let nextDate = null
  let startDate = start ? new Date(start) : new Date()
  let lastDate = lastCompletionDate ? new Date(lastCompletionDate) : null
  if (lastDate && lastDate > startDate) {
    startDate = lastDate
  }
  switch (frequency) {
    case 'weekly':
      nextDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate() + 7,
      )
      break
    case 'biweekly':
      nextDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate() + 14,
      )
      break
    case 'monthly':
      nextDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        startDate.getDate(),
      )
      break
    case 'quarterly':
      nextDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 3,
        startDate.getDate(),
      )
      break
    case 'semiannually':
      nextDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 6,
        startDate.getDate(),
      )
      break
    case 'annually':
      nextDate = new Date(
        startDate.getFullYear() + 1,
        startDate.getMonth(),
        startDate.getDate(),
      )
      break
    case 'biannually':
      nextDate = new Date(
        startDate.getFullYear() + 2,
        startDate.getMonth(),
        startDate.getDate(),
      )
      break
    default:
      nextDate = startDate
  }
  return nextDate
}

class MaintenancePlan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      tasks: [],
      targets: [],
      classes: [],
      maintenanceTaskModalOpen: false,
      selectedTask: null,
      loading: true,
      maintenanceTaskExecutionModalOpen: false,
      selectedExecution: null,
      executionListDialogOpen: false,
      taskExecutions: [],
    }
  }
  componentDidMount() {
    this.updateList()
    this.props.firebase.getMaintenanceTicketTargetsOnce().then((targets) => {
      this.setState({ targets: targets })
    })
  }

  componentDidUpdate(prevProps) {}

  getTaskExecutions = async (plantaskid) => {
    const executions =
      await this.props.firebase.getMaintenancePlanTaskExecutions(plantaskid)
    // add plan action name to each execution
    const enrichedExecutions = executions.map((execution) => {
      let enrichedExecution = { ...execution }
      const task = this.state.tasks.find(
        (t) => t.id === enrichedExecution.plantaskid,
      )
      enrichedExecution.planAction = task ? task.action : ''
      return enrichedExecution
    })

    this.setState({
      taskExecutions: enrichedExecutions,
      executionListDialogOpen: true,
    })
  }

  toggleMaintenanceTaskModal = () => {
    this.setState({
      maintenanceTaskModalOpen: !this.state.maintenanceTaskModalOpen,
      selectedTask: null,
    })
  }

  toggleMaintenanceTaskExecutionModal = () => {
    this.setState({
      maintenanceTaskExecutionModalOpen:
        !this.state.maintenanceTaskExecutionModalOpen,
    })
  }

  echancedDataSchema = () => {
    let _a = getMaintenancePlanTaskSchema()
    delete _a.properties.target.enum
    _a.properties.target.oneOf = this.state.targets.map((r) => ({ const: r.name, title: r.name }))

    return _a
  }

  updateList = () => {
    this.setState({ loading: true })
    this.props.firebase.getMaintenancePlanTasks().then((docs) => {
      const enrichedDocs = docs.map((task) => {
        // status field mapping
        let enrichedTask = { ...task }
        console.log('task', task)
        enrichedTask.status = 'done'
        // if nextduedate is missing or in the past, set status to overdue
        if (!task.nextduedate || task.nextduedate.toDate() < new Date()) {
          enrichedTask.status = 'overdue'
        }
        // if lastcompletiondate is missing and start date is in the past, set status to overdue
        else if (
          !task.lastcompletiondate &&
          task.startdate &&
          task.startdate.toDate() < new Date()
        ) {
          enrichedTask.status = 'overdue'
        }
        // if nextduedate is within 7 days, set status to upcoming
        else if (
          task.nextduedate &&
          task.nextduedate.toDate() >= new Date() &&
          task.nextduedate.toDate() <=
            new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
        ) {
          enrichedTask.status = 'upcoming'
        }
        return enrichedTask
      })
      console.log('updateList annetut tehtävät', enrichedDocs)
      this.setState({
        tasks: enrichedDocs,
        loading: false,
      })
    })
  }

  onSaveTask = async (task) => {
    this.setState({ saving: true })
    // startdate YYYY-MM-DD => new Date(startdate)
    // check type of task.startdate
    if (typeof task.startdate === 'string') {
      task.startdate = new Date(task.startdate)
    } else if (task.startdate && task.startdate.toDate) {
      task.startdate = task.startdate.toDate()
    }
    if (typeof task.lastcompletiondate === 'string') {
      task.lastcompletiondate = new Date(task.lastcompletiondate)
    } else if (task.lastcompletiondate && task.lastcompletiondate.toDate) {
      task.lastcompletiondate = task.lastcompletiondate.toDate()
    }
    const nextDueDate = getNextDueDate(
      task.lastcompletiondate,
      task.startdate,
      task.frequency,
    )
    task.nextduedate = nextDueDate
    delete task.status
    this.props.firebase.updateMaintenancePlanTask(task).then(() => {
      this.setState({ selectedTask: null, saving: false })
      this.updateList()
    })
  }

  onCreateTask = async (task) => {
    this.setState({ saving: true })
    this.props.firebase.createMaintenancePlanTask(task).then(() => {
      this.setState({ selectedTask: null, saving: false })
      this.updateList()
    })
  }


  onSaveExecution = async (execution) => {
    this.setState({ saving: true })
    // date YYYY-MM-DD => new Date(date)
    execution.date = new Date(execution.date)
    this.props.firebase.updateMaintenancePlanTaskExecution(execution).then(() => {
      console.log('suoritus tallennettu')
      this.updateList()
      console.log('päivitetyt tehtävät haettu')
      this.setState({ selectedExecution: null, saving: false })
    })
  }

  onCreateExecution = async (execution) => {
    this.setState({ saving: true })
    this.props.firebase.createMaintenancePlanTaskExecution(execution).then(() => {
      console.log('suoritus luotu')
      this.updateList()
      console.log('päivitetyt tehtävät haettu')
      this.setState({ selectedExecution: null, saving: false })
    })
  }

  // getColumnDefs = () => {
  //   return [
  //     { field: 'action', headerName: 'Toiminto', flex: 1 },
  //     { field: 'target', headerName: 'Kohde', flex: 1 },
  //     {
  //       field: 'frequency',
  //       headerName: 'Tiheys',
  //       flex: 1,
  //       valueFormatter: (params) => FREQS[params.value] || params.value,
  //     },
  //     {
  //       field: 'nextduedate',
  //       headerName: 'Seuraava kerta',
  //       flex: 1,
  //       valueFormatter: (params) =>
  //         params.value ? params.value.toDate().toLocaleDateString() : '',
  //     },
  //     { field: 'responsible', headerName: 'Vastuuhenkilö', flex: 1 },
  //     {
  //       field: 'lastcompletiondate',
  //       headerName: 'Viimeisin suoritus',
  //       flex: 1,
  //       valueFormatter: (params) =>
  //         params.value ? params.value.toDate().toLocaleDateString() : '',
  //     },
  //     { field: 'detailedtarget', headerName: 'Tarkennettu kohde', flex: 1 },
  //     { field: 'notes', headerName: 'Muistiinpanot', flex: 1 },
  //     {
  //       field: 'status',
  //       headerName: 'Tila',
  //       flex: 1,
  //       valueFormatter: (params) =>
  //         statusses[params.value]?.title || params.value,
  //       renderCell: (params) => {
  //         const status = statusses[params.value]
  //         return (
  //           <span>
  //             <i
  //               className={status?.icon}
  //               style={{ color: status?.color, marginRight: 5 }}
  //             ></i>
  //             {status?.title || params.value}
  //           </span>
  //         )
  //       },
  //     },
  //     {
  //       field: 'actions',
  //       headerName: '',
  //       sortable: false,
  //       width: 320,
  //       disableClickEventBubbling: true,
  //       renderCell: (params) => {
  //         return (
  //           <>
  //             <BootstrapButton
  //               disabled={this.state.loading}
  //               color='success'
  //               size='sm'
  //               onClick={(event) => {
  //                 event.stopPropagation()
  //                 this.setState(
  //                   {
  //                     selectedExecution: {
  //                       plantaskid: params.row.id,
  //                       date: new Date().toISOString().split('T')[0],
  //                       completedBy:
  //                         this.props?.firebase?.auth?.currentUser?.displayName,
  //                     },
  //                   },
  //                   () => {
  //                     this.toggleMaintenanceTaskExecutionModal()
  //                   },
  //                 )
  //               }}
  //             >
  //               Merkkaa suoritus
  //             </BootstrapButton>
  //             <BootstrapButton
  //               disabled={this.state.loading}
  //               color='warning'
  //               size='sm'
  //               onClick={(event) => {
  //                 event.stopPropagation()
  //                 this.setState({ taskplanTitle: params.row.action }, () =>
  //                   this.getTaskExecutions(params.row.id),
  //                 )
  //               }}
  //             >
  //               Näytä suoritukset
  //             </BootstrapButton>
  //           </>
  //         )
  //       },
  //     },
  //   ]
  // }

  render() {
    return (
      <div className='content'>
        <h3>Huoltosuunnitelma</h3>
        <Row>
          <Col xs='6'>
            <BootstrapButton
              color='primary'
              onClick={this.toggleMaintenanceTaskModal}
            >
              Lisää huoltotehtävä
            </BootstrapButton>
          </Col>
          <Col xs='6' className='text-right'>
            <BootstrapButton
              color='warning'
              onClick={() =>
                this.setState({ taskplanTitle: 'Kaikki suoritukset' }, () =>
                  this.getTaskExecutions(null),
                )
              }
              style={{ marginLeft: 10 }}
            >
              Kaikki suoritukset
            </BootstrapButton>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <CardGrid
              cards={this.state.tasks}
              columns={1}
              disableActions={this.state.loading}
              onEdit={(id) => {
                const task = this.state.tasks.find((t) => t.id === id)
                // format dates to YYYY-MM-DD string for the form
                if (task.startdate && task.startdate.toDate) {
                  task.startdate = task.startdate.toDate().toISOString().split('T')[0]
                }
                if (task.lastcompletiondate && task.lastcompletiondate.toDate) {
                  task.lastcompletiondate = task.lastcompletiondate.toDate().toISOString().split('T')[0]
                }
                this.setState({ selectedTask: task, maintenanceTaskModalOpen: true }
                  // , () =>
                  // this.toggleMaintenanceTaskModal(),
                )
              }}
              onDelete={async (id) => {
                if (window.confirm('Haluatko varmasti poistaa tehtävän?')) {
                  this.setState({ saving: true })
                  await this.props.firebase.deleteMaintenancePlanTask(id)
                  this.updateList()
                }
              }}
              onShowExecutions={(id) => {
                const task = this.state.tasks.find((t) => t.id === id)
                this.setState({ taskplanTitle: task.action }, () =>
                  this.getTaskExecutions(id),
                )
              }}
              onAddExecution={(id) => {
                const task = this.state.tasks.find((t) => t.id === id)
                this.setState(
                  {
                    selectedExecution: {
                      plantaskid: task.id,
                      date: new Date().toISOString().split('T')[0],
                      completedBy:
                        this.props?.firebase?.auth?.currentUser?.displayName,
                    },
                  },
                  () => {
                    this.toggleMaintenanceTaskExecutionModal()
                  }
                )
              }}
            />
          </Col>
        </Row>
        {/* <Row style={{ marginTop: 20 }}>
          <Col md='12'>
            <div
              style={{
                display: 'flex',
                minHeight: 'calc(100vh - 350px)',
                backgroundColor: 'white',
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <DataGrid
                  componentsProps={{ panel: { disablePortal: true } }}
                  rows={this.state.tasks}
                  columns={this.getColumnDefs()}
                  pageSize={10}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  disableSelectionOnClick
                  onRowClick={(rowData) => {
                    this.setState({
                      selectedTask: rowData.row,
                      maintenanceTaskModalOpen: true,
                    })
                  }}
                  loading={this.state.loading}
                  pagination
                />
              </div>
            </div>
          </Col>
        </Row> */}
        <FalconModal
          title={
            this.state.selectedTask
              ? 'Muokkaa huoltotehtävää'
              : 'Uusi huoltotehtävä'
          }
          size='lg'
          onCreate={this.onCreateTask}
          onUpdate={this.onSaveTask}
          resource={this.state.selectedTask}
          isOpen={this.state.maintenanceTaskModalOpen}
          toggle={this.toggleMaintenanceTaskModal}
          cancel={this.toggleMaintenanceTaskModal}
          dataSchema={this.echancedDataSchema()}
          uiSchema={getMaintenancePlanTaskUISchema()}
        />

        <FalconModal
          title='Huoltotehtävän suoritus'
          size='lg'
          onCreate={this.onCreateExecution}
          onUpdate={this.onSaveExecution}
          resource={this.state.selectedExecution}
          isOpen={this.state.maintenanceTaskExecutionModalOpen}
          toggle={this.toggleMaintenanceTaskExecutionModal}
          cancel={this.toggleMaintenanceTaskExecutionModal}
          dataSchema={getMaintenancePlanTaskExecutionSchema()}
          uiSchema={getMaintenancePlanTaskExecutionUISchema()}
        />
        <Dialog
          open={this.state.executionListDialogOpen}
          onClose={() => this.setState({ executionListDialogOpen: false })}
          maxWidth='lg'
          fullWidth={true}
        >
          <div style={{ padding: 20, minWidth: 500 }}>
            <h4>
              {this.state.taskplanTitle
                ? this.state.taskplanTitle
                : 'Suoritukset'}
            </h4>
            <div
              style={{
                display: 'flex',
                minHeight: 'calc(100vh - 200px)',
                backgroundColor: 'white',
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <DataGrid
                  componentsProps={{ panel: { disablePortal: true } }}
                  rows={this.state.taskExecutions}
                  columns={[
                    { field: 'planAction', headerName: 'Toiminto', flex: 1 },
                    {
                      field: 'date',
                      headerName: 'Päivämäärä',
                      flex: 1,
                      valueFormatter: (value) =>
                        value
                          ? value.toDate().toLocaleDateString()
                          : '',
                    },
                    { field: 'completedBy', headerName: 'Suorittaja', flex: 1 },
                    { field: 'note', headerName: 'Muistiinpano', flex: 2 },
                  ]}
                  pageSize={10}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  disableSelectionOnClick
                  loading={this.state.loading}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  pagination
                  localeText={{
                    toolbarDensity: 'Riviväli',
                    toolbarDensityLabel: 'Riviväli',
                    toolbarDensityCompact: 'Tiheä',
                    toolbarDensityStandard: 'Normaali',
                    toolbarDensityComfortable: 'Väljä',
                    toolbarExport: 'Lataa / Tulosta',
                    toolbarExportLabel: 'Lataa / Tulosta',
                    toolbarExportCSV: 'Lataa CSV',
                    toolbarExportPDF: 'Lataa PDF',
                    toolbarExportPrint: 'Tulosta',
                    toolbarFilters: 'Suodata',
                    toolbarFiltersLabel: 'Suodata',
                    toolbarColumns: 'Sarakkeet',
                    toolbarColumnsLabel: 'Sarakkeet',
                  }}
                />
              </div>
            </div>
          </div>
          {/* </div> */}
        </Dialog>
      </div>
    )
  }
}

export default withFirebase(MaintenancePlan)
